import _ from 'lodash'

import { gettext_noop } from 'lib/gettext'

const entrySources = [
  {
    pk: 0,
    slug: 'personal',
    name: gettext_noop('Personal expertise (default)'),
  },
  {
    pk: 1,
    slug: 'secondary',
    name: gettext_noop('Secondary source'),
  },
  {
    pk: 2,
    slug: 'expert',
    name: gettext_noop('Expert source'),
  },
  {
    pk: 3,
    slug: 'supervised',
    name: gettext_noop('Supervised entry'),
  },
]

const pkToSlugMapping = _.mapValues(_.keyBy(entrySources, 'pk'), 'slug')
const slugToPkMapping = _.mapValues(_.keyBy(entrySources, 'slug'), 'pk')

const entrySource = {
  getList() {
    return Promise.resolve(entrySources)
  },
}

export function dehydrate(entrySource) {
  return pkToSlugMapping[entrySource]
}

export function hydrate(entrySource) {
  return slugToPkMapping[entrySource]
}

export function hydrateSecondarySource(
  secondarySource,
  otherSecondarySourceName
) {
  if (secondarySource.pk === 0) {
    return { title: otherSecondarySourceName }
  } else {
    return secondarySource
  }
}

export default entrySource
